import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-N1H7EKLK68");
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
